module.exports = __webpack_public_path__ + "img/pssm_indicator3.b9845c78.png";